import { ReactNode } from "react";
import "./ppr-item-layout.less";
import { Typography, Flex } from "antd";

const { Title, Text } = Typography;

interface PprItemLayoutProps {
  title?: string;
  desc?: string;
  child?: ReactNode;
}

export const PprItemLayout = ({ title, desc, child }: PprItemLayoutProps) => {
  return (
    <Flex justify="space-between" align="start">
      <Flex vertical className="ppr-item-layout">
        <Title>{title}</Title>
        <Text className="ant-typography-text">{desc}</Text>
      </Flex>
         {child}
      </Flex>
  );
};
